import { VendorGeneralConditions as VendorGeneralConditionsComponent } from '../../../components/Vendor';

export function VendorGeneralConditions() {
  return <VendorGeneralConditionsComponent />;
}
